"use client";

import Image, { type ImageProps } from "next/image";
import { useEffect, useState, type ReactNode } from "react";

export interface SafeImageProps extends ImageProps {
  readonly fallback?: ReactNode;
}

/**
 * next/image wrapper that hides broken URLs instead of showing the browser broken-icon.
 */
export function SafeImage({
  src,
  fallback = null,
  onError,
  ...props
}: SafeImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return <>{fallback}</>;
  }

  return (
    <Image
      src={src}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
      {...props}
    />
  );
}
